<template>
  <div>
    <HeaderItem> </HeaderItem>
    <div class="subject">
      <div class="list-group">
        <routeTabComponent />
        <div class="panel">
          <el-scrollbar
            class="aeroiot-scrollbar"
            style="width: 100%; height: 100%"
          >
            <div class="InternetThings" v-loading="iotLoading">
              <!-- 用于以后接受数据
                      <div v-for="m in datadivst" :key="m.id">
                          </div> -->

              <!--设备  -->
              <div>
                <div class="equipment">
                  <div class="item">
                    <div class="leftBorderBlue"></div>
                    <span class="word">设备接入总数</span>
                    <span class="num">{{ stats.total }}</span>
                    <div class="addSensorButton" @click="openIot">
                      <div style="margin-top: -2px">+</div>
                    </div>
                  </div>

                  <div class="item">
                    <div class="leftBorderGreen"></div>
                    <span class="word">在线设备</span>
                    <span class="num">{{ stats.online }}</span>
                  </div>
                  <div class="item">
                    <div class="leftBorderGray"></div>
                    <span class="word">离线设备</span>
                    <span class="num">{{ stats.offline }}</span>
                  </div>
                </div>
                <div class="abnormal">
                  <div class="item" style="clear: both">
                    <span class="word">异常设备</span>
                    <span class="num">{{ stats.abnormal }}</span>
                  </div>

                  <div class="item">
                    <span class="word">电量异常</span>
                    <span class="num">{{ stats.batteryAbnormal }}</span>
                  </div>
                  <div class="item">
                    <span class="word">通讯异常</span>
                    <span class="num">{{ stats.connectionAbnormal }}</span>
                  </div>
                  <div class="item">
                    <span class="word">数据异常</span>
                    <span class="num">{{ stats.dataAbnormal }}</span>
                  </div>
                </div>
              </div>
              <div class="main">
                <div class="init" @click="openIot">进入物联网</div>
              </div>
            </div>
            <div class="capacity-module">
              <div class="topline"></div>
              <capacity-room />
              <capacity-detail />
              <!-- <capacity-table /> -->
            </div>
          </el-scrollbar>
        </div>
      </div>

      <SignIn></SignIn>
    </div>
    <telephoneModule />
  </div>
</template>

<script>
import SignIn from "@/components/SignIn";
import HeaderItem from "@/components/HeaderItem";
import telephoneModule from "@/components/telephoneModule";
import routeTabComponent from "@/components/routeTabComponent";
import capacityRoom from "./components/capacityRoom";
import capacityDetail from "./components/capacityDetail";
//import capacityTable from "./components/capacityTable";
import config from "@/utils/config";
export default {
  name: "InternetThings",
  data() {
    return {
      stats: {
        total: 0,
        online: 0,
        offline: 0,
        abnormal: 0,
        batteryAbnormal: 0,
        connectionAbnormal: 0,
        dataAbnormal: 0,
      },
      iotLoading: false,
    };
  },
  mounted() {
    this.loadStatData();
  },
  components: {
    SignIn,
    HeaderItem,
    routeTabComponent,
    telephoneModule,
    capacityRoom,
    capacityDetail,
    //capacityTable,
  },
  methods: {
    openIot() {
      window.open(config.iotUrl, "_blank");
    },
    loadStatData() {
      this.iotLoading = true;
      var statApi = this.$apis.statdata;
      this.$axios.get(statApi).then(
        (response) => {
          if (response.status === 200 && response.data) {
            var result = response.data;
            if (result.code === 200) {
              if (result.data) {
                this.stats = result.data;
              }
            } else {
              console.log("物联网设备统计数据查询失败:" + result.message);
            }
          } else {
            console.log("物联网设备统计数据查询失败:" + response.message);
          }
          this.iotLoading = false;
        },
        (error) => {
          this.iotLoading = false;
          console.log("物联网设备统计接口调用失败:" + error.message);
        }
      );
    },
  },
};
</script>


<style scoped>
a {
  text-decoration: none;
}

.subject {
  /* 20220523 隐藏左侧栏 */
  /* position: absolute; */
  /* width: calc(100% - 50px); */
  width: 100%;
  min-height: 100vh;
  background-color: #eaedf5;
  display: flex;
  flex-direction: row;
}

.subject .list-group {
  position: relative;
  margin: 63px 20px 20px 15px;
  min-height: calc(100vh - 83px);
}

.subject .list-group .panel {
  border-top: 1px solid;
  border-color: #e2e4e7;
  width: 100%;
  background-color: white;
  height: calc(100vh - 130px);
}

.InternetThings {
  display: flex;
  justify-content: space-between;
}

.InternetThings .item {
  position: relative;
  width: 187px !important;
  height: 80px !important;
  float: left;
  margin: 10px;
  background-color: #f5f7fb;
  color: black;
  font-size: 12px;
  border-left: 3px sodivd;
}

.InternetThings .equipment .item .word {
  position: absolute;
  color: #333333;
  font-weight: 1000;
  font-size: 12px;
  line-height: 23px;
  top: 14px;
  left: 21px;
}
.InternetThings .equipment .item .num {
  font-size: 24px;
  position: absolute;
  font-family: Microsoft YaHei;
  font-weight: bold;
  top: 36px;
  left: 21px;
}

.InternetThings .abnormal .item .word {
  position: absolute;
  color: #333333;
  font-weight: 1000;
  font-size: 12px;
  top: 15px;
  left: 15px;
}
.InternetThings .abnormal .item .num {
  font-size: 20px;
  position: absolute;
  color: #c80000;
  font-family: Microsoft YaHei;
  font-weight: bold;
  top: 38px;
  left: 15px;
}
.InternetThings .main {
  margin: 14px 20px 0 20px;
  /* border-top: 1px dashed #e2e4e7; */
  position: relative;
  padding-bottom: 20px;
}
.InternetThings .main .init {
  position: relative;
  margin: 31px 0 20px 10px;
  width: 138px;
  height: 42px;
  border-radius: 21px;
  text-align: center;
  line-height: 42px;
  color: white;
  background-color: #6c85ff;
  font-size: 14px;
  cursor: pointer;
}
.leftBorderBlue {
  position: absolute;
  left: 0;
  width: 3px;
  height: 80px;
  background: #6c85ff;
}
.leftBorderGreen {
  position: absolute;
  left: 0;
  width: 3px;
  height: 80px;
  background: #5ac951;
}
.leftBorderGray {
  position: absolute;
  left: 0;
  width: 3px;
  height: 80px;
  background: #8d8d8d;
}
.addSensorButton {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 13px;
  right: 12px;
  background-color: #6c85ff;
  border-radius: 50%;
  color: white;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.equipment {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.abnormal {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}
.aeroiot-scrollbar >>> .el-scrollbar__wrap {
  overflow-x: hidden;
}
.capacity-module {
  padding: 10px;
}
.topline {
  border-top: 1px dashed #e2e4e7;
  width: 100%;
  height: 1px;
  margin-bottom: 20px;
}
@media screen and (max-width: 555px) {
  .subject {
    background: rgba(240, 241, 243, 1);
  }
  .subject .list-group {
    margin: 50px 0px 20px 0px;
  }
  .el-scrollbar__wrap {
    margin: 0 !important;
  }
  .aeroiot-projects {
    background: rgba(240, 241, 243, 1);
    padding: 0;
    margin-top: 5px;
    justify-content: space-between;
  }
  .subject .list-group .panel {
    margin-top: 10px;
    height: calc(100vh - 120px);
    border: 0;
  }
  .subject .list-group .InternetThings {
    margin-top: 10px;
  }
  .InternetThings {
    flex-direction: column;
  }
  .InternetThings .equipment .item {
    width: 111px !important;
    height: 60px !important;
    margin: 14px 10px 10px 0px;
  }
  .InternetThings .equipment .item:first-child {
    margin-left: 11px;
  }
  .InternetThings .equipment .item .leftBorderBlue {
    height: 60px !important;
    width: 2px;
  }
  .InternetThings .equipment .leftBorderGreen {
    height: 60px !important;
    width: 2px;
  }
  .InternetThings .equipment .leftBorderGray {
    height: 60px !important;
    width: 2px;
  }
  .InternetThings .equipment .item .word {
    top: 5.5px;
    left: 11.5px;
    color: rgba(90, 91, 91, 1);
  }
  .InternetThings .equipment .item .num {
    top: 26.5px;
    left: 11.5px;
  }
  .addSensorButton {
    top: 35px;
    right: 9px;
  }

  .InternetThings .item {
    width: 80.5px !important;
    height: 60px !important;
    margin: 0 10px 10px 0;
  }
  .InternetThings .item:first-child {
    margin-left: 11px;
  }
  .InternetThings .abnormal .item .word {
    color: rgba(90, 91, 91, 1);
    top: 7.5px;
    left: 11.5px;
  }
  .InternetThings .abnormal .item .num {
    top: 28.5px;
    left: 11.5px;
  }
  .InternetThings .main {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    border-top: 1px dashed #e2e4e7;
    border-top: unset;
  }
  .InternetThings .main .init {
    width: 290px;
    height: 43px;
    background: rgba(108, 133, 255, 1);
    border-radius: 92px;
  }
}
</style>
<style>
.capacity-module-container {
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  padding: 16px;
  font-size: 14px;
  margin-bottom: 20px;
}
.capacity-module-top {
  padding-bottom: 6px;
  border-bottom: 1px solid #e5e6eb;
  display: flex;
  justify-content: space-between;
}
.capacity-module-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #6c85ff;
  background-color: #fff;
  color: #6c85ff;
  font-size: 14px;
  cursor: pointer;
  border-radius: 4px;
  padding: 4px 5px;
}
.capacity-module-filter {
  display: flex;
  align-items: center;
  position: absolute;
  right: 0;
  top: 10px;
  z-index: 1;
}
.capacity-module-select {
  position: absolute;
  left: 0;
  top: 10px;
  z-index: 1;
}
.capacity-module-middle {
  position: relative;
}
.capacity-module-content {
  min-height: 200px;
}
.refresh-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #6c85ff;
  background-color: #fff;
  color: #6c85ff;
  font-size: 14px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  border-radius: 4px;
}
.date-picker .el-input__inner {
  border-radius: 0;
}
.date-picker .el-range-editor.is-active {
  border-color: #6c85ff;
}
.el-date-range-picker .el-date-table td.today span,
.el-date-range-picker .el-date-table td.available:hover,
.el-picker-panel__shortcut:hover {
  color: #6c85ff;
}
.el-date-range-picker .el-date-table td.end-date span,
.el-date-range-picker .el-date-table td.start-date span {
  background-color: #6c85ff;
}
.timecategory-group .el-radio-group .el-radio-button .el-radio-button__inner {
  background: none;
  border: 0;
  padding: 7px;
  color: #252b3a;
}
.el-radio-button__inner:hover {
  color: #6c85ff;
}
.timecategory-group
  .el-radio-group
  .el-radio-button__orig-radio:checked
  + .el-radio-button__inner {
  color: #6c85ff;
  background: none;
  box-shadow: none;
  border: 0;
}
.capacity-module-charts {
  display: flex;
}
.capacity-module-chart {
  width: 100%;
  height: 330px;
}
.capacity-module-chart.left {
  width: 335px;
  flex-shrink: 0;
}
.capacity-module-chart.right {
  flex: 1;
}
.iottableselectoption.el-select-dropdown .el-select-dropdown__item {
  color: #252b3a;
}

.iottableselectoption.el-select-dropdown .selected {
  color: #6c85ff;
}
.capacity-module-table {
  width: calc(100vw - 560px);
  margin-top: 20px;
}
.aeroiot-table.el-table td,
.aeroiot-table.el-table th {
  color: #575d6c;
  padding: 6px 0;
  font-size: 13px;
}
.aeroiot-table.el-table .ascending .sort-caret.ascending{
  border-bottom-color: #6c85ff;
}
.aeroiot-table.el-table .descending .sort-caret.descending {
  border-top-color: #6c85ff;
}
.aeroiot-table.el-table td .cell,
.aeroiot-table.el-table th .cell {
  padding-left: 15px;
  padding-right: 0px;
}
.aeroiot-table.el-table .tableindex .cell {
  padding-left: 0;
}
.aeroiot-table.el-table .el-table__header-wrapper td,
.aeroiot-table.el-table .el-table__header-wrapper th,
.aeroiot-table.el-table .el-table__fixed-header-wrapper td,
.aeroiot-table.el-table .el-table__fixed-header-wrapper th {
  background-color: #f2f5fc;
  border-bottom: 2px solid #e7e8ec;
  border-right: 2px solid #ffffff;
}
.aeroiot-table.el-table .el-table__body-wrapper td,
.aeroiot-table.el-table .el-table__body-wrapper th,
.aeroiot-table.el-table .el-table__fixed-body-wrapper td,
.aeroiot-table.el-table .el-table__fixed-body-wrapper th {
  padding: 8px 0;
  border-color: #e7e8ec;
  height: 42px;
}

.aeroiot-pagination {
  margin-top: 35px;
}
.aeroiot-pagination button {
  min-width: 26px;
  height: 24px;
  padding: 0;
}
.aeroiot-pagination .btn-prev,
.aeroiot-pagination .btn-next {
  padding: 0;
  text-align: center;
}
.aeroiot-pagination .btn-prev .el-icon,
.aeroiot-pagination .btn-next .el-icon {
  padding: 0;
  text-align: center;
}
.aeroiot-pagination .el-pager {
  color: #575d6c;
}
.aeroiot-pagination .el-pager li {
  min-width: 19px;
  line-height: 24px;
  height: 24px;
  margin: 0 5px;
}
.aeroiot-pagination .el-pager li.more::before {
  line-height: 24px;
}
.aeroiot-pagination .el-pager li.active {
  background-color: #e9edfa;
  color: #575d6c;
}
@media screen and (max-width: 555px) {
  .capacity-module-charts {
    flex-direction: column;
  }
  .capacity-module-chart.left {
    width: 100%;
  }
  .capacity-module-chart.right {
    width: 100%;
    flex: none;
  }
  .capacity-module-filter .date-picker {
    display: none;
  }
  .capacity-module-select {
    position: static;
    margin-top: 10px;
  }
  .timecategory-group {
    margin: 0 5px !important;
  }
  .capacity-module-table {
    width: calc(100vw - 60px);
  }
}
</style>



// WEBPACK FOOTER //
// src/view/iot/index.vue